import React from 'react';
import { Navigate, RouteProps } from 'react-router-dom';
import { useConfig } from '../hooks/useConfig';
import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';

type ClientRouteProps = RouteProps & {
  /**
   * Deja pasar a quien no tiene membresía activa (`is_client=false`).
   *
   * Lo usa el selector de cursos: es el destino de los comunicados de
   * invitación, así que un usuario recién precargado tiene que poder abrirlo.
   * Sin esto rebotaba al home aunque el backend ya lo dejara pasar.
   */
  allowInactiveClient?: boolean;
};

export default function ClientRoute(
  props: ClientRouteProps,
): React.ReactElement {
  const config = useConfig();
  const { user } = useUser();

  if (config.expired_user_can_use_app || props.allowInactiveClient) {
    return <>{props.element}</>;
  }

  if (!user?.is_client) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return <Navigate to="/" />;
  }

  return <>{props.element}</>;
}
